import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { ColumnsType } from "antd/lib/table";
import TableComponent from "../../../../components/table/tableComponent";
import { HistoricoPlanoContaFinanceiroModel } from "../../../../models/planoContaFinanceiro/historicoPlanoContaFinanceiroModel";
import { useEffect } from "react";
import { listarHistoricoPlanoContaFinanceiro } from "../../../../services/planoContaFinanceiroService";
import dayjs from "dayjs";

dayjs.locale("pt-br");

const HistoricoPlanoContaFinanceiro = () => {
  //estados globais
  const planoContaFinanceiroState = useAppSelector((state) => state.planoContaFinanceiro);

  //hooks
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(listarHistoricoPlanoContaFinanceiro(planoContaFinanceiroState.entity.id));
  }, [planoContaFinanceiroState.entity]);

  const columns: ColumnsType<HistoricoPlanoContaFinanceiroModel> = [
    {
      title: "TIPO OPERAÇÃO",
      dataIndex: "tipoOperacao",
      align: "center",
      filters: [
        {
          text: "Criação",
          value: "Criação" as any,
        },
        {
          text: "Alteração",
          value: "Alteração" as any,
        },
        {
          text: "Desativação",
          value: "Desativação" as any,
        },
        {
          text: "Ativação",
          value: "Ativação" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.tipoOperacao.toString().includes(value),
    },
    {
      title: "DATA ALTERAÇÃO",
      dataIndex: "dataAlteracao",
      align: "center",
      sorter: (a, b) => dayjs(a.dataAlteracao).unix() - dayjs(b.dataAlteracao).unix(),
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => <>{dayjs(record.dataAlteracao).format("DD/MM/YYYY HH:mm")}</>,
    },
    {
      title: "USUARIO ALTERAÇÃO",
      dataIndex: "usuarioAlteracao",
      sorter: (a: any, b: any) => a.usuarioAlteracao.localeCompare(b.usuarioAlteracao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "DESCRIÇÃO ALTERAÇÃO",
      dataIndex: "descricaoOperacao",
      sorter: (a: any, b: any) => a.descricaoOperacao.localeCompare(b.descricaoOperacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
  ];

  return <TableComponent data={planoContaFinanceiroState.listHistorico} columns={columns} loading={planoContaFinanceiroState.loadingHistorico} />;
};

export default HistoricoPlanoContaFinanceiro;
